import { render, staticRenderFns } from "./ToggleRouterLink.vue?vue&type=template&id=4096a4fd"
import script from "./ToggleRouterLink.vue?vue&type=script&lang=js"
export * from "./ToggleRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports